import { useMemo } from 'react';
import styled from 'styled-components';
import { SLINKY } from 'HubStyleTokens/colors';
import UIBreakString from 'UIComponents/text/UIBreakString';
import Grid from '../Grid';
import GridItem from '../GridItem';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledHeader = styled.div.withConfig({
  displayName: "Requirement__StyledHeader",
  componentId: "sc-1rf39jm-0"
})(["font-weight:", ";font-size:13px;color:", ";"], ({
  theme
}) => theme.typography['display-500'].fontWeight, SLINKY);
const StyledValue = styled.div.withConfig({
  displayName: "Requirement__StyledValue",
  componentId: "sc-1rf39jm-1"
})(["font-size:12px;"]);
const StyledGrid = styled(Grid).withConfig({
  displayName: "Requirement__StyledGrid",
  componentId: "sc-1rf39jm-2"
})(["width:100%;"]);
const Requirement = ({
  header,
  value
}) => {
  const headerColumns = useMemo(() => ({
    mobile: 12,
    base: 12,
    desktop: 4
  }), []);
  const valueColumns = useMemo(() => ({
    mobile: 12,
    base: 12,
    desktop: 8
  }), []);
  return /*#__PURE__*/_jsxs(StyledGrid, {
    children: [/*#__PURE__*/_jsx(GridItem, {
      columns: headerColumns,
      children: /*#__PURE__*/_jsx(StyledHeader, {
        children: header
      })
    }), /*#__PURE__*/_jsx(GridItem, {
      columns: valueColumns,
      children: /*#__PURE__*/_jsx(StyledValue, {
        children: /*#__PURE__*/_jsx(UIBreakString, {
          children: value
        })
      })
    })]
  });
};
export default Requirement;